import React from "react";
import BedModelPage from "../common/BedModelPage";

function Classic() {
  const images = [
    "/123",
  ];

  const description =
    "...";


  return (
    <BedModelPage
      title="..."
      images={images}
      description={description}
      variation="..."
    />
  );
}

export default Classic;
